module.exports = __webpack_public_path__ + "img/dypitch-3.af88363d.jpg";